/* @NOTE Contents of this file is *generated*, DO NOT EDIT */

export const Home = (): string => `/`;

export const Docs = (pagePath?: string): string =>
	`/docs${pagePath ? `/${pagePath}` : ''}`;

export const Reference = (pagePath?: string): string =>
	`/reference${pagePath ? `/${pagePath}` : ''}`;

export const Login = (): string => `/login`;

export const Organizations = (): string => `/organizations`;

export const Keys = (): string => `/keys`;

export const KeyCreate = (): string => `/keys/new`;

export const Key = (key: string): string => `/keys/${key}`;

export const KeyAccess = (key: string): string => `/keys/${key}/access`;

export const KeyRotate = (key: string): string => `/keys/${key}/rotate`;

export const KeyRevoke = (key: string): string => `/keys/${key}/revoke`;
